import { DATE_DATABASE_FORMAT } from "@/common/constants";
import { format } from "date-fns";
export const collectionToPostDistanceMission = ({ missions, }) => {
    return missions.map((item) => {
        return {
            isInitialChecked: item.can_post === 1,
            canPostReason: item.can_post_reason ?? "",
            distanceToFinish: item.distance_to_finish ?? 0,
            id: +item.id,
            image: item.image,
            image_extension: item.image_extension,
            launch_date: item.launch_date,
            locked: item.locked,
            name: item.name,
        };
    });
};
export const postDistanceFormToObject = (item) => {
    const date = item.startDate.split(" ");
    const now = new Date();
    // format date
    const parsedDate = Date.parse(`${date[0].replace(/(\d+)(st|nd|rd|th)/g, "$1")} ${date[1]} ${date[2]} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`);
    const datecreated = format(parsedDate, DATE_DATABASE_FORMAT);
    return {
        comment: item.comment,
        exercise_type: item.exerciseType,
        missions: item.missionsToPost,
        datecreated: datecreated,
        travelled: +item.travelled,
        distance_unit: item.distanceUnit,
        file_path: item.filePath,
    };
};
